import { connect } from 'react-redux';
import { ConnectedRouter } from '@jauntin/react-ui';
import { formValueSelector } from 'redux-form';
import { formName } from '../Constants/constants';
import RouteParser from '../Helpers/RouteParser';
import EventSelect from '../Components/EventSelect/EventSelect';
import { iconEventTypes, listEventTypes } from '../Helpers/EventTypes';

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => ({
  show: state.formPage.formPage === RouteParser.formParts.eventType,
  valid: state.formPage.eventSelect.valid,
  eventTypeRadio: formValues(state, 'eventTypeRadio'),
  eventTypeSelect: formValues(state, 'eventTypeSelect'),
  iconEventTypes: iconEventTypes(
    state.formPage.eventTypes,
    state.formPage.venue.eventTypes,
  ),
  listEventTypes: listEventTypes(
    state.formPage.eventTypes,
    state.formPage.venue.eventTypes,
  ),
  sortedEventTypes: state.formPage.venue.eventTypes,
});

const mapDispatchToProps = (dispatch) => ({
  select: (value) =>
    dispatch(
      ConnectedRouter.push(
        new RouteParser(`/${value}`).linkToEventQuestionsPage(),
      ),
    ),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  select: (event) => {
    let value;
    if (event.target.value) {
      ({ value } = event.target);
    } else {
      value = stateProps.eventTypeSelect;
    }
    return dispatchProps.select(value);
  },
});

const EventSelectContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(EventSelect);

export default EventSelectContainer;
